var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row justify-center items-center",
      staticStyle: { height: "80vh" }
    },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-5" },
        [
          _c(
            "q-card",
            [
              _c(
                "q-card-main",
                [
                  _c(
                    "vue-plyr",
                    {
                      ref: "plyr",
                      attrs: {
                        options: {
                          listeners: {
                            seek: _vm.activity.user_watch ? "" : _vm.seekVideo
                          }
                        }
                      }
                    },
                    [
                      _c(
                        "audio",
                        { ref: "player", attrs: { playsinline: "" } },
                        [
                          _c("source", {
                            attrs: {
                              src:
                                _vm.getResource +
                                "#t=" +
                                _vm.activity.current_time,
                              type: _vm.$mime.lookup(_vm.activity.resource)
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }